import React, {useEffect, useState} from 'react';
import {Icon} from '../index';
import {t} from '@insight/toolkit-utils';
export default function ShortTermLeasingConfimationModal({
    onClose
}) {
    return (
        <div className="c-short-term-leasing__form-modal__confirmation o-grid o-grid--justify-between">
            <div className="o-grid">
                <div className="o-grid__item  o-grid__item--shrink">
                    <Icon 
                        type="success"
                        title="success"
                        icon="checkmark-circled"
                    />
                </div>
                <div className="o-grid__item">
                    <span>{t('Your leasing inquiry has been successfully submitted. An Insight specialist will contact you within 48 business hours.')}</span>
                </div>
            </div>
            <div className='c-short-term-leasing__form-modal__confirmation__button-container o-grid__item--bottom'>
                <div className='o-grid'>
                    <div className='o-grid__item'>
                        <button
                            className="c-button  c-button--primary c-short-term-leasing__form-modal__confirmation__button"
                            onClick={onClose}
                        >
                            {t('Close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}